import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getApprovalData(token) {
  return axios.get(`/review/${token}/post`)
}

export function approvePost(token, authorName) {
  return axios.post(`/review/${token}/approve`, {
    comment: { author_name: authorName }
  })
}

export function requestChanges(token, body, authorName) {
  return axios.post(`/review/${token}/request_changes`, {
    comment: { body, author_name: authorName }
  })
}

export function addComment(token, body, authorName) {
  return axios.post(`/review/${token}/comments`, {
    comment: { body, author_name: authorName }
  })
}
